'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseApplicationTypes', ['$scope', 'ApplicationTypes', '$stateParams', '$q', function ($scope, ApplicationTypes, $stateParams, $q) {
        $scope.resetLicense();
        $scope.saving = false;
        $scope.loading = true;

        ApplicationTypes.get({ license_id: $stateParams.id }).then(function (types) {
            $scope.application_types = types;
            $scope.loading = false;
        })

        $scope.checkAll = function (event, checkAll, levels, type) {
            event.stopImmediatePropagation();
            type.license_category_levels = [];
            levels.forEach(function (obj) {
                if (checkAll) {
                    type.license_category_levels.push(obj);
                }
            })
        }

        $scope.save = function () {
            $scope.saving = true;
            var promises = [];

            $scope.application_types.forEach(function (type) {
                promises.push(ApplicationTypes.save(type, $stateParams.id));
            })

            $q.all(promises).then(function () {
                $scope.saving = false;
                $scope.loading = true;
                ApplicationTypes.get({ license_id: $stateParams.id }).then(function (types) {
                    $scope.application_types = types;
                    $scope.loading = false;
                })
            }).catch(function (response) {
                // handle error
            });
        }
    }])
;